import React from 'react';
import { Container } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import EmployeesTable from './components/EmployeesTable'

const EmployeesTableList = (props) => (

    <Container>
        <EmployeesTable {...props} />
    </Container>
);

EmployeesTableList.propTypes = {
    t: PropTypes.func.isRequired,
};

export default withTranslation('common')(EmployeesTableList);

